export default "__VITE_PUBLIC_ASSET__31c95cc1__"